import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, List } from 'tea-component';
import { FilterContext } from '@/pages/opinion/pages/Summary/context';
import { getFeedsComments } from '@/pages/opinion/services';
import Tips from '@/pages/opinion/components/Snippets/Tips';
import ChatItem from '@/pages/opinion/components/Snippets/ChatItem';
import { feedsContentMap } from '@/pages/opinion/utils/languageValue';
import KeywordColumn from '@/pages/opinion/components/KeywordColums';
import ReviewsModal from '@/pages/opinion/components/ReviewsModal';
import useReviewModalData from '@/pages/opinion/components/ReviewsModal/useReviewModalData';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
export default function KeywordAndFeeds({
  showKeys,
  id,
  setActiveElementHeight,
  language,
}: any) {
  let { filter, transTopic, clickTopicToFeedsFunc } = useContext(FilterContext);
  let [loading, setLoading] = useState(false);
  let [apiError, setApiError] = useState(false);

  const getFeedsComment = () => {
    setLoading(true);
    setApiError(false);
    setActiveElementHeight(133);
    getFeedsComments({
      ...filter,
      topic: [id],
      page: 1,
      page_size: 3,
      sort_item: 'important_score',
      sort_model: 'desc',
      review_type: 'all',
    })
      .then((data: any) => {
        let { list } = data;
        setChatList(list || []);

        setTimeout(() => {
          const element = document?.getElementById('keywordAndFeeds' + id);
          setActiveElementHeight(element?.offsetHeight || 133);
        }, 10);
      })
      .catch(() => {
        setChatList([]);
        setApiError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [keywordParams, setKeywordParams] = useState({});

  useEffect(() => {
    if (id && filter.edition_unified_id && showKeys.includes(id)) {
      setKeywordParams({
        ...filter,
        topic: [id],
        keyword_top_n: 5,
        keyword_sample_size: '30',
        sort_item: 'important_score',
        sort_model: 'desc',
        review_type: 'all',
      });
      getFeedsComment();
    } else {
      setKeywordParams({});
    }
  }, [id, filter]);

  const [chatList, setChatList] = useState<Array<any>>([]);
  const { formatMessage } = useIntl();
  const { reviewsVisible, data, openModal, toggleModal } = useReviewModalData();

  const { goPage } = useDrilldownParams();

  return (
    <div
      id={'keywordAndFeeds' + id}
      className={`keyword-and-feeds-wrapper ${
        showKeys.includes(id) ? 'active' : ''
      }`}
    >
      <Card className="detail-info-box">
        <Card.Body
          title={
            <p
              className="detail-info-box-title"
              onClick={() => {
                buriedBtnPoint('STO_toFeeds');
                clickTopicToFeedsFunc(id, 'L2');
              }}
            >
              {transTopic(id, 'L2')}
              <SvgIcon type="arrow-right" className="detail-info-box-svg" />
              {/* <img src={jumpInIcon}></img> */}
            </p>
          }
          className="dbo-detail-info"
        >
          <Tips
            noData={chatList.length === 0}
            loading={loading}
            apiError={apiError}
            loadingText={formatMessage({ id: 'Loading' })}
            className={
              apiError || loading || chatList.length === 0 ? 'tips' : ''
            }
          >
            <>
              <KeywordColumn
                params={keywordParams}
                className="dbo-summary-keywords"
                language={language}
                noDateText="No keyword"
                tipsClass="tips-info"
                onClick={(keyword, children) => {
                  goPage({
                    path: '/opinion/Stats/Detail',
                    filter: {
                      filter: {
                        ...filter,
                        keyword: children,
                        keyword_widely_match: true,
                        topic: [id],
                      },
                      statsDetailType: 'topic-tracking-keyword',
                    },
                  });
                }}
              ></KeywordColumn>
              <List className="dbo-list-box">
                {chatList?.map((item) => (
                  <ChatItem
                    key={item.comment_uin + item.content}
                    className="dbo-list-item"
                    item={item}
                    itemClick={() => openModal(item)}
                    theme="white"
                    language={language}
                    languageMap={feedsContentMap}
                    iconStyle={{ width: 20, height: 20 }}
                  ></ChatItem>
                ))}
              </List>
            </>
          </Tips>
        </Card.Body>
      </Card>
      <ReviewsModal
        visible={reviewsVisible}
        data={data}
        language={language}
        close={toggleModal}
      />
    </div>
  );
}
